<div
  #wrapper
  class="wrapper"
  [ngClass]="{
    'nav-collapsed': iscollapsed,
    'menu-collapsed': iscollapsed,
    'sidebar-sm': isSidebar_sm,
    'sidebar-lg': isSidebar_lg
  }"
  [dir]="options.direction"
>
  <div
    #appSidebar
    appSidebar
    class="app-sidebar"
    routerLinkActive
    [ngClass]="{ 'hide-sidebar': hideSidebar, collapsed: iscollapsed }"
    data-active-color="white"
    [attr.data-background-color]="bgColor"
    [attr.data-image]="bgImage">

      <div class="appSidebarContent">
        <app-sidebar (sidebarToggle)="handleSidebarToggle($event)"></app-sidebar>
      </div>
      <div class="sidebarProfile">
        <a class="header-icon user-icon"  ngbTooltip="Profile" placement="bottom" (click)="Navprofile()">
          <img alt="Profile" src="assets/card/profile.svg"  style="height: 44px" />
        </a>
   
        <div class="profile-info" *ngIf="!isCollapsed">
          <p class="profile-name" style="margin: 0">{{ userData.username || "" }}</p>
          <p class="profile-email" style="margin: 0">{{ userData.email || "" }}</p>
        </div>
   
        <a class="header-icon logout" (click)="logOut()" href="javascript:;" ngbTooltip="Logout" placement="right">
          <img alt="Logout" src="assets/card/Logout.svg" />
        </a>
      </div>
    
    <!-- <app-sidebar (sidebarToggle)="handleSidebarToggle($event)"></app-sidebar>
    <div *ngIf="!isCollapsed" class="profile-section bottom-0">
      <a class="header-icon user-icon" [routerLink]="['/profile']" ngbTooltip="Profile" placement="bottom">
        <img alt="Profile" src="assets/card/profile.svg" style="height: 36px" />
      </a>
 
      <div class="profile-info">
        <p class="profile-name" style="margin: 5px 2px 5px;">{{ userData.username || "" }}</p>
        <p class="profile-email" style="margin: 5px 2px 5px;">{{ userData.email || "" }}</p>
      </div>
 
      <a class="header-icon logout" (click)="logOut()" href="javascript:;" ngbTooltip="Logout" placement="bottom">
        <img alt="Logout" src="assets/card/Logout.svg" />
      </a>
    </div>
    <div *ngIf="isCollapsed" class="profile-section left-0"
      style="display: flex; flex-direction: column ; height: 7rem">
 
      <a class="header-icon user-icon" [routerLink]="['/profile']" ngbTooltip="Profile" placement="bottom">
        <img alt="Profile" src="assets/card/profile.svg" style="height: 36px" />
      </a>
 
      <a class="header-icon" (click)="logOut()" href="javascript:;" ngbTooltip="Logout" placement="bottom"
        style="margin-bottom: 8px;">
        <img alt="Logout" src="assets/card/Logout.svg" class="logout" />
      </a> 
    </div> -->
  </div>
  <div class="main-panel">
    <router-outlet></router-outlet>
    <!-- <div class="main-content">
      <div class="content-wrapper">
        <div class="container-fluid">
          <div class="routeroutlet">
            <router-outlet></router-outlet>
          </div>
        </div>
      </div>
    </div> -->
    <app-footer></app-footer>
  </div>

  <!-- <div
    class="main-panel"
    (isCollapsedChange)="onSidebarCollapsedChange($event)"
  >
    <div class="main-content">
      <div class="content-wrapper">
        <div class="container-fluid">
          <router-outlet></router-outlet>
        </div>
      </div>
    </div>
  </div> -->
  <!-- <button class="toggle-btn" (click)="toggleSidebar()">
    <i *ngIf="iscollapsed" class="fa fa-arrow-right"></i>
    <i *ngIf="!iscollapsed" class="fa fa-arrow-left"></i>
  </button> -->

</div>
